import { render } from "./cardJob.vue?vue&type=template&id=6a843bbe"
import script from "./cardJob.vue?vue&type=script&lang=js"
export * from "./cardJob.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__